/**
 * This service used to call POST API URL to different rules throught application
 */
/**
 * Import required modules/plugin
 */
import axios from '../axios-config';
import store from '../store/store';

const patchrulesAPI = {
  patchApi(requestParams) {
    /* eslint no-param-reassign: "error" */
    return new Promise((resolve, reject) => {
      axios.patch(requestParams.url, requestParams.data)
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  },
  /**
   * This function used to call all navigation tab rule for RC2  where user moved from
   * one tab to other tab. Form patch need to call in all navigation
   * Accepts formData as parameter contains all form field name and field value object
   * returns new navigation url where user going route after API call
   */
  navigationFormPatch(formDataArr) {
    /**
     * Prepared form data from vuex store and function parameters
     */
    console.log('formDataArr for patch ', formDataArr);
    const formData = {
      page_name: store.getters.getPageName,
      fields: formDataArr.data,
    };

    return new Promise((resolve, reject) => {
      axios.patch(formDataArr.url, formData)
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  },
};
/**
 * export service to used by different components
 */

export default patchrulesAPI;



// WEBPACK FOOTER //
// ./src/services/patchData.js